import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { AttendanceProcedureReqEval } from "@/@types/esus/AttendanceProcedureReqEval";

type IndicatorEsfC7CitizenProceduresHistoryItemProps = {
	attendanceProcedureReqEval: AttendanceProcedureReqEval;
};

export function IndicatorEsfC7CitizenProceduresHistoryItem({
	attendanceProcedureReqEval,
}: Readonly<IndicatorEsfC7CitizenProceduresHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{attendanceProcedureReqEval.healthTeam1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{attendanceProcedureReqEval.healthUnit1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{attendanceProcedureReqEval.professional1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{attendanceProcedureReqEval.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					{attendanceProcedureReqEval.attProcedureRequested &&
						attendanceProcedureReqEval.attProcedureRequested.procedureCode !== "-" && (
							<p>
								<span className="fw-bold text-primary">
									Solicitação de procedimento:{" "}
								</span>
								{`${attendanceProcedureReqEval.attProcedureRequested.procedureCode} - ${attendanceProcedureReqEval.attProcedureRequested.name}`}
							</p>
						)}
				</Col>
				<Col>
					{attendanceProcedureReqEval.attProcedureEvaluated &&
						attendanceProcedureReqEval.attProcedureEvaluated.procedureCode !== "-" && (
							<p>
								<span className="fw-bold text-primary">
									Solicitação de procedimento:{" "}
								</span>
								{`${attendanceProcedureReqEval.attProcedureEvaluated.procedureCode} - ${attendanceProcedureReqEval.attProcedureEvaluated.name}`}
							</p>
						)}
				</Col>
			</Row>
		</>
	);
}
